import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { HOST } from 'marketing-website/configs/urls';
import { fetchApi } from 'marketing-website/utils/fetch';
import { getIntercomEventUrl } from 'marketing-website/constants/api';

import styles from './style/general.module.css';

export default class UpgradeLink extends Component {
  onButtonClick = () => {
    fetchApi('POST', getIntercomEventUrl('paywall_viewed'), {
      delay: 0,
      metadata: {
        source: 'clicked_pro_header',
      },
    })
      .then(this.redirectTo())
      .catch(this.redirectTo());
  };

  redirectTo = () => {
    window.location.href = `${HOST}/upgrade`;
  };

  render() {
    const { color, isLoggedIn, isSubscribed, isVisible } = this.props;

    const containerClasses = cx(styles.container, {
      [styles.containerBlue]: color === 'blue',
      [styles.containerWhite]: color === 'white',
    });

    const ctaClasses = cx(styles.cta, {
      [styles.ctaBlue]: color === 'blue',
      [styles.ctaWhite]: color === 'white',
    });

    if (!isLoggedIn || !isVisible || isSubscribed) {
      return null;
    }

    return (
      <div className={containerClasses} onClick={this.onButtonClick}>
        <svg className={styles.svg} width="4" height="10" viewBox="0 0 4 10">
          <path d="M4 10l-3.435-3.868c-.75-.625-.756-1.635 0-2.264l3.435-3.868v10z" />
        </svg>
        <span className={ctaClasses}>
          <span className={styles.copy}>Upgrade</span>
        </span>
      </div>
    );
  }
}

UpgradeLink.propTypes = {
  color: PropTypes.oneOf(['white', 'blue']),
  isLoggedIn: PropTypes.bool,
  isSubscribed: PropTypes.bool,
  isVisible: PropTypes.bool,
};

UpgradeLink.defaultProps = {
  color: 'blue',
  isLoggedIn: false,
  isSubscribed: false,
  isVisible: false,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/UpgradeLink/UpgradeLink.js